module.exports = __webpack_public_path__ + "static/media/spotify.56eab5ba.svg";